import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useCreateFolder = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();

  return useMutation(
    trpc.folders.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getUserFolders.queryKey(),
        });
        toast.success("Folder created successfully");
      },
      onError: (error) => {
        console.error("Failed to create folder", error);
        toast.error(error.message);
      },
    }),
  );
};
